module.exports = __webpack_public_path__ + "img/bb-terms.ee58351.webp";